import type { MoralStepData, MoralStepRequest } from './models';

import { saveOnboardingStep } from './onboarding-step';

const saveOnboardingMoralStep = saveOnboardingStep<
  MoralStepData,
  MoralStepRequest
>('No se pudo guardar el paso');

export const createMoralPersonalData = (body: MoralStepRequest) =>
  saveOnboardingMoralStep('post', '/onboarding/personal/data/moral', body);

export const updateMoralPersonalData = (body: MoralStepRequest) =>
  saveOnboardingMoralStep('put', '/onboarding/personal/data/moral', body);

export const saveMoralLegalRepresentative = (body: MoralStepRequest) =>
  saveOnboardingMoralStep(
    'post',
    '/onboarding/legal/representative/moral',
    body,
  );

export const createMoralEconomicInformation = (body: MoralStepRequest) =>
  saveOnboardingMoralStep(
    'post',
    '/onboarding/economic/information/moral',
    body,
  );

export const updateMoralEconomicInformation = (body: MoralStepRequest) =>
  saveOnboardingMoralStep(
    'put',
    '/onboarding/economic/information/moral',
    body,
  );

export const createMoralBankAccount = (body: MoralStepRequest) =>
  saveOnboardingMoralStep('post', '/onboarding/account/moral', body);

export const updateMoralBankAccount = (body: MoralStepRequest) =>
  saveOnboardingMoralStep('put', '/onboarding/account/moral', body);
